import { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { Room as LocationOnIcon } from "@mui/icons-material"; // MUI Location Icon
import { createRoot } from "react-dom/client";
import { Avatar, Box, Card, CardContent, Grid, Typography } from "@mui/material";

const EventMap = ({ eventDetails }) => {
  const [location, setLocation] = useState(null);
  const [muiIcon, setMuiIcon] = useState(null);

  useEffect(() => {
    if (eventDetails) {
      setLocation({
        lat: eventDetails.eventLatitude,
        lng: eventDetails.eventLongitude,
      });
    }
  }, [eventDetails]);

  useEffect(() => {
    // ✅ Ensure the hook runs only once, not conditionally
    const div = document.createElement("div");
    div.style.width = "40px"; // Set size
    div.style.height = "40px";

    // Render the MUI Icon inside Leaflet's divIcon
    const root = createRoot(div);
    root.render(<LocationOnIcon sx={{ color: "red", fontSize: 40 }} />);

    // Create and set the Leaflet divIcon
    setMuiIcon(
      L.divIcon({
        className: "custom-marker",
        html: div,
        iconSize: [40, 40], // Match MUI size
      })
    );
  }, []);

  if (!location || !muiIcon) return <p>Loading map...</p>;

  return (
   
      <MapContainer center={[location.lat, location.lng]} zoom={100} style={{ height: "400px", width: "100%" }}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Marker position={[location.lat, location.lng]} icon={muiIcon}>
          <Popup>{eventDetails?.eventName || "Event Location"}</Popup>
        </Marker>
      </MapContainer>
    
  );
};

export default EventMap;
